<template>
    <div class="page-container">
        <div class="page-notice">将您的津贴金额划转至您的御粮账户中，已划转的金额不可再提现</div>
        <div class="page-content">
            <div class="section">
                <div class="section-title">划转金额 <span>(已划转的金额不可再提现)</span></div>
                <div class="input-grp" style="border-bottom:1px solid #f0f0f0;justify-content:flex-start;">
                    <div style="color:#333;font-size:18px;">¥</div>
                    <input type="text" v-model="realAmount" style="font-size:30px;color:#333;text-align:left;margin-left:10px;background:transparent;" placeholder="请输入金额">
                </div>
                <div class="section-bottom">
                    可划转津贴 ¥{{amount}}
                    <span>全部</span>
                </div>
            </div>
            <div class="btn-confirm" v-if="realAmount > 0" @click="showPasswordLayer = true">确认划转</div>
            <div class="btn-confirm disabled" v-else>确认划转</div>
        </div>
        <!-- 输入密码弹层 -->
        <van-overlay :show="showPasswordLayer">
            <div class="wrapper">
                <div class="layer-content-block" :class="{'wrapper-to-top':showKeyboard}">
                    <div class="content-title">请输入交易密码 <van-icon name="cross" class="btn-close" size="22" color="#d2d2d2" @click.stop="showPasswordLayer = false" /></div>
                    <div class="content-bottom">
                        <div class="pay-detial">划转金额</div>
                        <div class="price">
                            ¥ <span>{{realAmount}}</span>
                        </div>
                        <div class="account-info"><span>转出账户</span><span>战略合伙人津贴</span></div>
                        <!-- 密码输入框 -->
                        <van-password-input
                        :value="password"
                        :focused="showKeyboard"
                        @focus="showKeyboard = true"
                        />
                        <!-- <div class="err-notice">您输入的密码错误，还剩下4次机会</div> -->
                        <div class="layer-btn-confirm" @click="confirm">确认进货</div>
                    </div>
                </div>
            </div>
        </van-overlay>
        <!-- 数字键盘 -->
        <van-number-keyboard
        v-model="password"
        :show="showKeyboard"
        @blur="showKeyboard = false"
        />
    </div>
</template>

<script>
import { Overlay,Icon,PasswordInput,NumberKeyboard,Toast } from 'vant'

import $http from '@/lib/request'
import config from '@/config'
import md5 from 'js-md5'

export default {
    data(){
        return{
            amount:0,
            realAmount:0,
            showPasswordLayer:false,
            password:'',
            showKeyboard:false,
        }
    },
    components:{
        [Overlay.name]:Overlay,
        [Icon.name]:Icon,
        [PasswordInput.name]:PasswordInput,
        [NumberKeyboard.name]:NumberKeyboard,
        [Toast.name]:Toast
    },
    watch:{
        showPasswordLayer(val,oldVal){
            this.password='';
        }
    },
    created(){
        this.amount=this.$route.params.amount;
    },
    methods:{
        confirm(){
            $http({
                method:'post',
                data:{
                    jyPassword:md5(this.password),
                    amount:this.realAmount
                },
                url:config.api.confirmHz
            }).then(res=>{
                if(res.errno == 0){
                    this.$router.push({
                        name:'index'
                    });
                }else{
                    Toast(res.errmsg);
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
::v-deep .van-password-input{
    margin:0;
}
.wrapper-to-top{
    transform: translateY(-40%);
}
.layer-content-block {
    background-color: #fff;
    width:300px;
    border-radius: 8px;
    .content-title{
        height:50px;
        line-height: 50px;
        text-align: center;
        position: relative;
        color:#333;
        font-size: 18px;
        .btn-close{
            position: absolute;
            right:15px;
            top:50%;
            transform: translateY(-50%);
        }
    }
    .content-bottom{
        padding:20px 28px;
        .pay-detial{
            font-size: 13px;
            color:#333;
            line-height: 18px;
            text-align: center;
            margin-bottom: 5px;
        }
        .price{
            text-align: center;
            color:#333;
            font-size: 26px;
            font-weight: 500;
            font-family: PingFangSC-Medium, PingFang SC;
            margin-bottom: 20px;
            &>span{
                font-size: 36px;
            }
        }
        .account-info{
            border-top:1px solid #f0f0f0;
            padding-top: 15px;
            line-height: 18px;
            margin-bottom: 25px;
            @include flex-between();
            &>span{
                font-size: 13px;
                color:#333;
                &:last-child{
                    font-weight: 500;
                }
            }
        }
        .err-notice{
            margin-top: 10px;
            color:#E43D3D;
            font-size: 13px;
            line-height: 18px;
        }
        .layer-btn-confirm{
            height:40px;
            line-height: 40px;
            text-align: center;
            border-radius: 26px;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            color:#fff;
            font-size: 16px;
            margin-top: 25px;
        }
    }
}
.page-container{
    min-height: 100vh;
    background:#f5f5f5;
    .page-notice{
        line-height: 20px;
        background: #E6F1FF;
        padding:8px 10px;
        font-size: 14px;
        color:#1671E1;
    }
    .page-content{
        padding:15px 10px;
        .section{
            background:#fff;
            border-radius: 4px;
            padding:15px;
            padding-bottom: 0;
            margin-bottom: 10px;
            .section-title{
                color:#333;
                font-size: 15px;
                line-height: 21px;
                font-weight: 500;
                margin-bottom: 10px;
                &>span{
                    color:#999;
                    font-size: 13px;
                    margin-left: 5px;
                }
            }
            .input-grp{
                height:44px;
                @include flex-between();
                .name{
                    font-size: 14px;
                    color:#333;
                }
                &>input{
                    border:none;
                    text-align: right;
                }
            }
            .section-bottom{
                height:44px;
                line-height: 44px;
                font-size: 13px;
                color:#999;
                &>span{
                    color:#328DF7;
                    margin-left: 10px;
                }
            }
        }
        .btn-confirm{
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            border-radius: 26px;
            font-size: 16px;
            color:#fff;
            margin:0 auto;
            margin-top: 50px;
            &.disabled{
                background:#dcdcdc;
                color:#999;
            }
        }
    }
}
</style>